import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function BellOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_62)'>
        <path
          d='M20.5201 15.21L18.7201 13.4V8.94002C18.744 7.28384 18.1679 5.67493 17.0982 4.41035C16.0285 3.14578 14.5373 2.31095 12.9001 2.06002C11.9499 1.93488 10.9839 2.01383 10.0667 2.29159C9.14942 2.56935 8.30194 3.03954 7.5808 3.67078C6.85965 4.30202 6.28142 5.07979 5.88468 5.95221C5.48794 6.82463 5.28182 7.77163 5.28007 8.73002V13.4L3.48007 15.21C3.25398 15.4399 3.10066 15.7313 3.03927 16.0478C2.97789 16.3643 3.01117 16.6919 3.13495 16.9897C3.25873 17.2874 3.46752 17.542 3.73522 17.7217C4.00292 17.9014 4.31766 17.9982 4.64007 18H8.00007V18.34C8.04678 19.3552 8.49403 20.3105 9.2438 20.9965C9.99357 21.6826 10.9847 22.0434 12.0001 22C13.0154 22.0434 14.0066 21.6826 14.7563 20.9965C15.5061 20.3105 15.9534 19.3552 16.0001 18.34V18H19.3601C19.6825 17.9982 19.9972 17.9014 20.2649 17.7217C20.5326 17.542 20.7414 17.2874 20.8652 16.9897C20.989 16.6919 21.0223 16.3643 20.9609 16.0478C20.8995 15.7313 20.7462 15.4399 20.5201 15.21ZM14.0001 18.34C13.9446 18.821 13.7057 19.2621 13.3331 19.5713C12.9606 19.8805 12.4831 20.0341 12.0001 20C11.5171 20.0341 11.0396 19.8805 10.667 19.5713C10.2944 19.2621 10.0555 18.821 10.0001 18.34V18H14.0001V18.34ZM5.51007 16L6.69007 14.82C6.87724 14.634 7.02574 14.4127 7.127 14.169C7.22826 13.9253 7.28028 13.6639 7.28007 13.4V8.73002C7.28062 8.05542 7.42546 7.38874 7.70487 6.77473C7.98428 6.16071 8.3918 5.61357 8.90007 5.17002C9.40149 4.7157 9.99565 4.37577 10.6414 4.17375C11.2872 3.97173 11.9691 3.91245 12.6401 4.00002C13.7966 4.18779 14.8463 4.78703 15.596 5.6874C16.3457 6.58776 16.7449 7.72865 16.7201 8.90002V13.4C16.7186 13.6632 16.769 13.9242 16.8685 14.1678C16.9681 14.4115 17.1147 14.6331 17.3001 14.82L18.4901 16H5.51007Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_62'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
